module.exports = __webpack_public_path__ + "static/media/OTCXR2.ff45638b.png";